import { CommentDataType, TABLE_COMMENT_DATA_TYPES } from './Comments.types'

export const checkIfTableDataType = (dataType: CommentDataType) => {
    const tableDataTypes: CommentDataType[] = Array.from(TABLE_COMMENT_DATA_TYPES)
    return tableDataTypes.includes(dataType)
}

export const getCommentsDashboardTabIdByDataType = (dataType?: CommentDataType) => {
    switch (dataType) {
        case 'tppCell':
            return 'tpp'
        case 'strategicImperative':
        case 'strategicImperativeTable':
            return 'strategicImperative'
        case 'valueMessage':
        case 'valueNarrative':
        case 'valueMessageTable':
            return 'valueMessage'
        case 'activity':
        case 'activityTable':
            return 'activity'
        case 'evidence':
        case 'evidenceTable':
            return 'evidence'
        default:
            return null
    }
}
